module.exports = __webpack_public_path__ + "static/media/AsesoriaImgEng.6efd2850.png";